import { useEffect, useState } from "react";

function ConfirmEmail(props) {

    const confirmationCode = props.match.params.code
    const startupId = props.match.params.startupId

    const [success, setSuccess] = useState(false)
    const [done, setDone] = useState(false)

    useEffect(() => {
        const confirmationUrl = process.env.REACT_APP_MAIL_CONFIRMATION_LAMBDA_URL || 'https://f1j07exi8h.execute-api.eu-central-1.amazonaws.com/dev/lambda_survey'
        fetch(`${confirmationUrl}?code=${confirmationCode}&startupid=${startupId}`)
            .then(response => {
                setSuccess(response.status === 200)
                setDone(true)
            })
            .catch(_ => setDone(true))
    }, [confirmationCode, startupId])
  
    return (
        <div>
            {done && success && (
            <div className="mail-confirmation-result">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                </div>
                <h1>Email confirmed</h1>
                <p>Thank you for confirming your email. Your startup is now visible on our startup map.</p>
            </div>  
            )}

            {done && !success && (
            <div className="mail-confirmation-result">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>        
                </div>
                <h1>Email confirmation failed</h1>
                <p>The confirmation of your email failed. Please contact us directly to complete your registration.</p>
            </div>   
            )}
        </div>
    )
  }

  export default ConfirmEmail
  